module.exports = __webpack_public_path__ + "static/media/Westrich-PurdySq.2c039cbf.jpg";